var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5970279,
    cx: 35.4863,
    cy: 35.6047,
    r: 34.5,
    stroke: "white",
    fillOpacity: 0.20648,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6002 28.2149V36.7198L40.3266 39.6435L41.535 37.7124L37.8876 35.4562V28.2149H35.6002ZM48.8828 35.6435C48.8828 38.8488 47.6537 41.8623 45.4219 44.1288C43.1902 46.3953 40.2229 47.6435 37.0667 47.6435V44.9059C42.0957 44.9059 46.1871 40.7508 46.1871 35.6435C46.1871 30.5362 42.0957 26.3811 37.0667 26.3811C32.2047 26.3811 28.2194 30.2648 27.96 35.1378H30.314L26.5984 41.6737L22.8828 35.1378H25.2615C25.3838 32.1223 26.5974 29.3051 28.7114 27.1583C30.9432 24.8917 33.9105 23.6435 37.0667 23.6435C40.2229 23.6435 43.1902 24.8917 45.4219 27.1583C47.6537 29.4248 48.8828 32.4382 48.8828 35.6435Z",
    id: "mask-fill-icon"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.f81eda6e03d918915f4137deba1455b8.svg";
export { ForwardRef as ReactComponent };